// Extend Date prototype globally
Date.prototype.toISOStringZ = function () {
    return this ? this.getFullYear() + '-' + (this.getMonth() + 1).toString().padStart(2, '0') + '-' + this.getDate().toString().padStart(2, '0') + 'T' + this.getHours().toString().padStart(2, '0') + ':' + this.getMinutes().toString().padStart(2, '0') + ':' + this.getSeconds().toString().padStart(2, '0') : null
}
 
export default defineNuxtPlugin((nuxtApp) => {
    const locale = () => nuxtApp.$i18n?.locale || 'en'
 
    const filters = {
        datetime: (val) => {
            if (!val || (typeof val !== 'string') || (val.indexOf && val.indexOf('0000-00-00') === 0)) {
                return ''
            }
 
            let date
            if(val instanceof Date) {
                date = val
            }else{
 
 
                if (val.match(/\d{4}-\d{2}-\d{2}\s/)) {
                    val = val.replace(' ', 'T')
                }
 
                date = new Date(val)
            }
 
            return date.toLocaleString(locale().value ?? 'en')
        },
 
        datetime2: (val) => {
            if (!val || (val.indexOf && val.indexOf('0000-00-00') === 0)) {
                return ''
            }
 
            let date
            if(val instanceof Date) {
                date = val
            }else{
 
                if (val.match(/\d{4}-\d{2}-\d{2}\s/)) {
                    val = val.replace(' ', 'T')
                }
            
 
                date = new Date(val)
            }
 
 
            return `${date.toLocaleDateString(locale().value ?? 'en')} ${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`
        },
 
        time: (val) => {
            if (!val || (val.indexOf && val.indexOf('0000-00-00') === 0)) {
                return ''
            }
 
            let date
            if(val instanceof Date) {
                date = val
            }else{
 
                if (val.match(/\d{4}-\d{2}-\d{2}\s/)) {
                    val = val.replace(' ', 'T')
                }
            
 
                date = new Date(val)
            }
 
            return `${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`
        },
 
        date: (val) => {
            if (!val || (val.indexOf && val.indexOf('0000-00-00') === 0)) {
                return ''
            }
            
            if(!isNaN(val)){
                val = val.toString()
            }
 
            let date
            if(val instanceof Date) {
                date = val
            }else{
 
 
                if (val.match(/\d{4}-\d{2}-\d{2}\s/)) {
                    val = val.replace(' ', 'T')
                }
 
                date = new Date(val)
            }
 
            return date.toLocaleDateString(locale().value ?? 'en')
        },
 
        // fix for components using 'date' as prop or data
        dateFilter: (val) => {
            if (!val || (val.indexOf && val.indexOf('0000-00-00') === 0)) {
                return ''
            }
 
            let date
            if(val instanceof Date) {
                date = val
            }else{
 
 
                if (val.match(/\d{4}-\d{2}-\d{2}\s/)) {
                    val = val.replace(' ', 'T')
                }
 
                date = new Date(val)
            }
 
            return date.toLocaleDateString(locale().value ?? 'en')
        },
 
        month: (val) => {
            if (!val || (val.indexOf && val.indexOf('0000-00-00') === 0)) {
                return ''
            }
 
            let date
            if(val instanceof Date) {
                date = val
            }else{
 
                    
                if (val.match(/\d{4}-\d{2}-\d{2}\s/)) {
                    val = val.replace(' ', 'T')
                }
 
                date = new Date(val)
            }
 
            return `${date.getFullYear()}/${date.getMonth() + 1}`
        },
 
        number0: (val) => {
            const float = parseFloat(val)
            if (!float) {
                return '-'
            }
            return Intl.NumberFormat(locale().value ?? 'en').format(Math.round(float))
        },
 
        number0w0: (val) => {
            const float = parseFloat(val)
            if (!float) {
                return '0'
            }
            return Intl.NumberFormat(locale().value ?? 'en').format(Math.round(float))
        },
 
        number2: (val) => {
            const float = parseFloat(val)
            if (!float) {
                return '-'
            }
            return Intl.NumberFormat(locale().value ?? 'en', {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
            }).format(float)
        },
 
        number4: (val) => {
            const float = parseFloat(val)
            if (!float) {
                return '-'
            }
            return Intl.NumberFormat(locale().value ?? 'en', {
                maximumFractionDigits: 4,
                minimumFractionDigits: 4
            }).format(float)
        },
 
        number5: (val) => {
            const float = parseFloat(val)
            if (!float) {
                return '-'
            }
            return Intl.NumberFormat(locale().value ?? 'en', {
                maximumFractionDigits: 5,
                minimumFractionDigits: 5
            }).format(float)
        },
 
        number2w0: (val) => {
            const float = parseFloat(val)
            if (!float) {
                return '0'
            }
            return Intl.NumberFormat(locale().value ?? 'en', {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
            }).format(float)
        },
 
        number1w0: (val) => {
            const float = parseFloat(val)
            if (!float) {
                return '0'
            }
            return Intl.NumberFormat(locale().value ?? 'en', {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1
            }).format(float)
        },
 
        fileSize: (val) => {
            val = parseInt(val)
            if (val > 1000000) {
                return (val / 1000000).toFixed(1) + ' MB'
            } else if (val > 1000) {
                return (val / 1000).toFixed(1) + ' KB'
            } else if (val > 1000) {
                return (val).toFixed(2) + ' B'
            }
        }
    }
 
    // Register filters as global properties (for Options API components)
    Object.keys(filters).forEach(filter => {
        nuxtApp.vueApp.config.globalProperties[`${filter}`] = filters[filter]
    })
 
})